import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditDialogComponent } from '../../../../../core/components/editDialog/editDialogComponent';
import { EditDialogInstance } from '../../../../../core/components/editDialog/editDialogService';
import { LoadingService } from '../../../../../core/services/loading.service';

@Component({
  selector: 'app-refuel-form-dialog',
  template: `
    <div [formGroup]="refuelForm" class="form flex flex-col">
        <nx-edit-number-input
            [suffix]="suffix"
            [formControlName]="controlKey"
            [label]="label">
        </nx-edit-number-input>
    </div>
  `,
  styles: [`
  `]
})
export class RefuelFormDialogComponent implements EditDialogInstance {
  
  refuelForm: FormGroup;
  controlKey: string;
  label: string;
  suffix: string;
  
  readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig);

  constructor() {
    this.controlKey = this.config?.data?.template?.body[0]?.controls[0]?.controls[0]?.key || 'refueled';
    this.label = this.config?.data?.template?.body[0]?.controls[0]?.controls[0]?.settings?.label || 'Nachgetankt';
    this.suffix = this.config?.data?.template?.body[0]?.controls[0]?.controls[0]?.settings?.suffix || 'l';
    this.refuelForm = new FormGroup({
      [this.controlKey]: new FormControl(null, [Validators.required, Validators.min(0)])
    });
  }

  getEditForm(): FormGroup {
    return this.refuelForm;
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {

    // build the formModelInput structure
    let refueledValue = {
      refueled: this.refuelForm.get(this.controlKey).value
    }
    let controlModelInput = {
      controlKey: this.controlKey,
      value : refueledValue
    };
    let controlModelInputs = [];
    controlModelInputs.push(controlModelInput);
    let formModelInput = {
      controlModelInputs: controlModelInputs
    };
    this.ref.close(formModelInput);
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }
}
